export enum AIQualityLevelEnum {
  BEST = 'best',
  GOOD = 'good',
  AVERAGE = 'average',
  BAD = 'bad',
  WORST = 'worst',
}